import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Tabs, Collapse, Grid, TabsProps } from 'antd'
import { AppealFiles } from '../tab-files'
import { AppealTimeline } from '../tab-timeline'
import { setTimelineClear } from '../../../../../store/timeline/actions'
import { getTimeLineData, getTimeLineFiles } from '../../../../../store/timeline/action-creators'
import { setStagePlanClear } from '../../../../../store/stagePlan/actions'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'
import MontageForms from '../montage-forms/montage-forms'
import { StyledCollapse } from '../../../../../components/v2/field-group/styles'
import EntityRelations from '../../../../../components/entity-relations'
import { TimelineTab } from '../../styles'
import styled, { css } from 'styled-components'

const { useBreakpoint } = Grid

interface AppealsTabsProps {
  onChange?: (key: string) => void
  onTabClick?: (key: string) => void
  id: string | number
  className?: string
}

const StyledTabs = styled(Tabs)<{ $isChatsActive: boolean }>`
  ${({ $isChatsActive }) =>
    $isChatsActive &&
    css`
      .ant-tabs-ink-bar {
        background-color: #007909;
      }
    `}
`

export const MontageTabs: React.FC<AppealsTabsProps> = memo((props: AppealsTabsProps) => {
  const { onChange, onTabClick, id, className } = props
  const dispatch = useAppDispatch()
  const screens = useBreakpoint()
  const isMobile = !screens.md
  const [activeKey, setActiveKey] = useState<string>('data')
  const [timelineLoaded, setTimelineLoaded] = useState<boolean>(false)
  const [fullTimelineLoaded, setFullTimelineLoaded] = useState<boolean>(false)

  useEffect(() => {
    dispatch(setStagePlanClear())
    return () => {
      dispatch(setTimelineClear())
      dispatch(setStagePlanClear())
    }
  }, [dispatch])

  const handleOnChange = useCallback(
    key => {
      setActiveKey(key)
      if (id !== 'new') {
        if (key === 'timeline' && !fullTimelineLoaded) {
          dispatch(getTimeLineData('case', id))
          setTimelineLoaded(true)
          setFullTimelineLoaded(true)
        } else if (key === 'files' && !timelineLoaded) {
          dispatch(getTimeLineFiles('case', id))
          setTimelineLoaded(true)
        }
      }
      if (onChange) {
        onChange(key)
      }
    },
    [dispatch, id, timelineLoaded, fullTimelineLoaded, onChange],
  )

  const handleOnTabClick = useCallback(
    key => {
      if (onTabClick) {
        onTabClick(key)
      }
    },
    [onTabClick],
  )

  const tabItems = useMemo<TabsProps['items']>(() => {
    const items: TabsProps['items'] = [
      {
        key: 'data',
        label: 'Данные заказа',
        children: <MontageForms id={id} />,
      },
      /*
      {
        key: 'products',
        label: 'Состав заказа',
        children: <TabProducts id={id} />
      }
      */
      {
        key: 'timeline',
        label: 'Лента событий',
        destroyOnHidden: true,
        children: isMobile ? (
          <>
            {/*
            <StyledCollapse ghost>
              <Collapse.Panel header={'Прогноз исполнения'} key={'stage-plan-panel'}>
                <AppealStagePlan id={id} hideHeader />
              </Collapse.Panel>
            </StyledCollapse>*/}
            <StyledCollapse defaultActiveKey={['timeline-panel']} ghost>
              <Collapse.Panel header={'Лента событий'} key={'timeline-panel'}>
                <AppealTimeline id={id} hideHeader />
              </Collapse.Panel>
            </StyledCollapse>
          </>
        ) : (
          <TimelineTab>
            {/*<AppealStagePlan id={id} />*/}
            <AppealTimeline id={id} />
          </TimelineTab>
        ),
      },
    ]
    /*
    if (!isMobile) {
      items.push({
        key: 'chats',
        label: <span style={{ color: '#007909' }}>Чаты</span>,
        children: <Chats id={id} />,
      })
    }
    */
    return [
      ...items,
      {
        key: 'files',
        label: 'Прикрепленные файлы',
        children: <AppealFiles id={id} />,
      },
      {
        key: 'relations',
        label: 'Связи',
        children: <EntityRelations entityType="montage" entityId={id} />,
      },
    ]
  }, [id, isMobile])

  return (
    <StyledTabs
      onChange={handleOnChange}
      onTabClick={handleOnTabClick}
      activeKey={activeKey}
      items={tabItems}
      className={className}
      $isChatsActive={activeKey === 'chats'}
    />
  )
})

MontageTabs.displayName = 'MontageTabs'

export default MontageTabs
